import React from 'react';
import { FadeIn } from './FadeIn';
interface PullQuoteProps {
  text: string;
  className?: string;
  textClassName?: string;
}
export function PullQuote({
  text,
  className = '',
  textClassName = 'text-navy'
}: PullQuoteProps) {
  return <FadeIn data-id="element-245">
      <div className={`my-4 md:my-10 py-3 md:py-5 border-y border-gold/40 text-center relative ${className}`} data-id="element-246">
        <p className={`font-serif text-2xl md:text-5xl font-bold tracking-wide ${textClassName}`} data-id="element-247">
          {text}
        </p>
      </div>
    </FadeIn>;
}